<div class="tw-flex tw-justify-center tw-items-center">
  <p class="no-data-message">
    {{ 'common.list.noData' | translate }}
  </p>
</div>
